import React from 'react';
import '../styles/HeroImage.css'; // Keep your existing CSS import

const HeroImage = () => (
  <div className="hero-container">
    <video 
      className="hero-video"
      autoPlay
      muted
      loop
      playsInline
    >
      <source src="/video/beach2.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div className="hero-gradient"></div>
  </div>
);

export default HeroImage;